import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontRightDoorInteriorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontRightDoorInterior(props: FrontRightDoorInteriorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Right Door"
      width={310}
      height={95}
      viewBox="0 0 310 95"
      position={{top: -28, left: 409}}
    >
      <path
        d="M304.904 47.3048C308.902 54.233 309.236 60.1916 308.902 62.3048L282.911 62.0001C231.927 62.0001 140.015 60.4895 82.0163 61.0421L32.9899 63.0001C29.9908 62.0001 27.6937 61.5651 25.9921 61.0001C6.18142 54.4223 1 35.9753 1 29.0001H295.906C297.239 32.1134 300.905 40.3766 304.904 47.3048Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M8.99747 48.5218C86.5768 49.0382 194.928 49.3596 306.903 50.6088L8.99747 48.5218Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M32.9899 63.0001C57.9819 59.0001 211.074 62.0001 282.911 62.0001H308.902C309.236 59.8869 308.902 54.233 304.904 47.3048C300.905 40.3766 297.239 32.1134 295.906 29.0001L1 29.0006C1 35.9757 6.18142 54.4223 25.9921 61.0001C27.6937 61.5651 29.9908 62.0001 32.9899 63.0001Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M32.9898 63.0001C40.342 61.8234 58.78 61.2198 82.974 61.0001L82.1891 60.2052C80.3108 58.2582 78.2437 55.6475 79.9544 53.0333C86.4033 54.0118 93.1575 54.2967 97.2068 53.6613C103.637 52.6522 111.273 4.85698 108.306 2.83899C105.338 0.820972 95.2277 -2.84077 79.4009 13.3019C74.0047 18.8058 69.8339 24.2013 67.0454 29.1241L66.9791 29.0001C65.1591 32.2954 59.9813 41.4001 55.9825 47.0001C51.9838 52.6001 38.9879 60.0001 32.9898 63.0001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M79.4009 13.3023C95.2283 -2.8411 105.338 0.821266 108.306 2.83925C111.274 4.85724 103.637 52.6518 97.2067 53.6609C90.7768 54.6699 77.5269 53.3601 69.5088 50.634C57.6382 46.5981 62.5552 30.4844 79.4009 13.3023Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M90.9715 54.0001C95.9699 49.0001 103.967 20.0001 103.967 2.00012"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M66.9791 29.0001C65.1591 32.2954 59.9813 41.4001 55.9825 47.0001C51.9838 52.6001 38.9879 60.0001 32.9898 63.0001C40.342 61.8234 58.78 61.2198 82.974 61.0001C80.9746 59.0001 77.9756 56.0001 79.9749 53.0001"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M244.923 39.0001C259.855 38.9999 279.764 37.0001 277.773 34.0001C271.033 23.8439 252.886 24.0001 244.923 24.0001C236.959 24.0001 218.812 23.8439 212.072 34.0001C210.081 37.0001 229.99 38.9999 244.923 39.0001ZM227.928 33.0001C229.693 30.757 232.418 29.0002 236.925 29.0001H252.92C257.428 29.0002 260.152 30.7569 261.917 33.0001H227.928Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M277.774 34.0002C271.033 23.8438 252.886 24.0003 244.923 24.0003C236.959 24.0003 218.812 23.8438 212.071 34.0002C210.08 37.0001 229.99 38.9999 244.923 39.0001C259.855 38.9999 279.765 37.0001 277.774 34.0002Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M263.917 38.0001C263.583 35.3335 260.917 29.0001 252.92 29.0001C244.923 29.0001 244.923 29.0001 244.923 29.0001C244.923 29.0001 244.923 29.0001 236.925 29.0001C228.928 29.0001 226.262 35.3335 225.929 38.0001"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M227.928 33.0001H261.917"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M175 94.0001C183.23 94.0001 189.117 91.908 193 88.8331V89.0001H255C259.995 89.0001 284.948 89.0001 284.999 77.0372H309V62.0773H282.91C211.074 62.0773 57.9836 59.0851 32.9902 63.0743H33C22.2442 65.0472 17.2645 71.2193 16 74.045V74.1925C26.6449 76.843 44 81.5323 44 91.0001C44 81.0267 52 77.0372 66 77.0372H73V78.0568C73 94 76 94.0001 85 94.0001H175Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M66 77.0374L309 77.0373V62.0772H282.911C211.074 62.0772 57.9819 59.0852 32.9898 63.0746L33 63.0746C22.2439 65.0475 17.2643 71.2197 16 74.0453V74.1929C26.6449 76.8434 44 81.5323 44 91.0001C44 81.0267 52 77.0374 66 77.0374Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M73 78.0568C73 94.0001 76 94.0001 85 94.0001H175C192 94.0001 199 85.0725 199 77.0001"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M193 89.0001H255C260 89.0001 285 89.0001 285 77.0001"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="102"
        y="82.0002"
        width="7"
        height="7"
        rx="3.5"
        transform="rotate(90 102 82.0002)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="91"
        y="84.0001"
        width="3"
        height="8"
        rx="1.5"
        transform="rotate(90 91 84.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="268"
        y="66.0001"
        width="7"
        height="7"
        rx="3.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
